import { User } from "../../user";
import { WorkflowOperator } from ".";

// ワークフロー行き先model
export class WorkflowDestination {

  // 進捗名
  public statusName: string;

  // フェーズID
  public phaseId: string;

  // アクションID
  public actionId: string;

  // 差戻し先ユーザ
  public actor: User;

  // 実施時刻
  public operationTime: Date;

  // 実施者
  public operator: WorkflowOperator;

}
